/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} PendingInputs */



/**
* | output |
* | --- |
* | "Pending..." |
*
* @param {PendingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const pending = /** @type {((inputs?: PendingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<PendingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("En attente...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ausstehend...")
	if (locale === "it") return /** @type {LocalizedString} */ ("In attesa di...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("В ожидании...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Pendiente...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("待办的...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("保留中...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लंबित...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Pendente...")
	return /** @type {LocalizedString} */ ("Pending...")
});